import { CommonModule } from "@angular/common";
import {
  Component,
  inject
} from "@angular/core";
import { NgbCarouselModule, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
  CardData,
  GenericCardComponent,
} from "../../../components/common/generic-card/generic-card.component";
import { LoadingComponent } from "../../../components/common/loading/loading.component";
import { ProjectConfigurationComponent } from "../../../components/modal-templates/project-configuration/project-configuration.component";
import { MessageEnum } from "../../../core/utils/message.enum";
import { BaseLayoutComponent } from "../../base-layout.component";

@Component({
  selector: "app-overview-agentic-ai",
  standalone: true,
  imports: [
    NgbCarouselModule,
    CommonModule,
    GenericCardComponent,
    LoadingComponent
  ],
  templateUrl: "./overview-agentic-ai.component.html",
  styleUrl: "./overview-agentic-ai.component.scss",
})
export class OverviewAgenticAIComponent extends BaseLayoutComponent {
  projectId: string = "";
  isActive = false;
  columns: any = [
    {
      key: 'a',
      display_name: 'Column A'
    },
    {
      key: 'b',
      display_name: 'Column B',
      _config: {
        type: 'image_with_text',
        prefixImage: {
          targetKey: 'source',
          values: {
            'mozilla': 'assets/images/virtusa-icons/firefox.png',
            'chrome': 'assets/images/virtusa-icons/chrome.png',
            'edge': 'assets/images/virtusa-icons/edge.png'
          }
        },
        suffixImage: {
          targetKey: 'isShl',
          values: {
            true: 'assets/images/virtusa-icons/shl.png'
          }
        }
      }
    },
    {
      key: 'c',
      display_name: 'Column C'
    }
  ];
  data: any = [
    {
      a: 'kdsd',
      b: 'value 1',
      c: 'value 2',
      source: 'mozilla',
      isShl: true
    },
    {
      a: 'kdsd',
      b: 'value 1',
      c: 'value 2'
    }
  ];

  slides = [
    "assets/images/virtusa-icons/frame1.svg",
    "assets/images/virtusa-icons/frame2.svg",
    "assets/images/virtusa-icons/frame3.svg",
    "assets/images/virtusa-icons/frame4.svg",
  ];
  isLoading: boolean = false;
  userQuery: string = "";

  cardItems: CardData[] = [];
  // [
  //   {
  //     title: "",
  //     description:
  //       "Write detailed functional test cases for a login page covering valid login, invalid credentials, and input validation scenarios",
  //     type: "design",
  //   },
  //   {
  //     title: "",
  //     description:
  //       "Generate a test agent configuration and test plan for executing tests on an e-commerce web application",
  //     type: "execution",
  //   },
  //   {
  //     title: "",
  //     description:
  //       "Generate a test execution report that identifies all failed test cases, including their error messages, and related test suites",
  //     type: "analytics",
  //   },
  //   {
  //     title: "",
  //     description:
  //       "Generate a test execution report that identifies all failed test cases, including their error messages, and related test suites",
  //     type: "maintenance",
  //   },
  // ];
  userProfile: any;
  private modalService = inject(NgbModal);

  onQueryChange(event: any): void {
    this.userQuery = event.target.value;
  }

  ngOnInit(): void {

    // Get projectId from ProjectService
    this.projectService.getProjectId().subscribe((id: string | null) => {
      this.projectId = id || "";
      if (localStorage.getItem("t_id")) {
        this.getChatHistory(localStorage.getItem("t_id"));
      }
      this.verifyAndPopConfigModal();
    });
    this.userProfile = this.authRealmService.getUserProfile();
    this.getSampleChats();
  }

  verifyAndPopConfigModal() {
    this.restService
      .getSurveySubmission(this.projectId)
      .subscribe((item) => {
        const answers = item?.data?.answers;
        let isAlreadySubmitted = answers?.filter((item: any) => item?.answer);

        if (!isAlreadySubmitted.length) {
          this.loadProjectConfigs();
        }
      });
  }

  loadProjectConfigs() {
    const modalRef = this.modalService.open(ProjectConfigurationComponent, {
      centered: true,
      windowClass: "scrip-mapping-modal",
      backdrop: 'static',
    });
    if (this.dataStore?.data?.id) {
      modalRef.componentInstance.data = this.projectId;
    }
  }

  getChatHistory(threadId: any): void {
    this.restService
      .getChatHistory(this.dataStore?.data?.id, threadId)
      .subscribe({
        next: (response: any) => {
          this.aiStreamingService.clearLastChat();
          this.agenticAiService.setHistory(
            this.agenticAiService.processChatHistory(response)
          );
          this.sideNav.setTreeNode("workspace");
        },
        error: (error: any) => {
          console.error(
            "An error occurred while retrieving chat history:",
            error
          );
          this.toaster.pop({
            type: "error",
            text: MessageEnum.FETCH_CHAT_HISTORY_FAILURE,
          });
        },
      });
  }

  sendQuery(): void {
    if (this.userQuery.trim()) {
      console.log("User query:", this.userQuery);
      this.aiStreamingService.clearLastChat();
      // TODO: Send query to AI service
      // Example: this.aiService.sendQuery(this.userQuery).subscribe(...)

      this.agenticAiService.setMessage(this.userQuery);
      this.sideNav.setTreeNode("workspace");
      this.userQuery = "";
    }
  }

  /**
   * Handles the click event from a generic card.
   * Sets the loading state on the card and pre-fills the query.
   * @param clickedCard The card data from the clicked card.
   */
  onCardClick(clickedCard: CardData): void {
    if (clickedCard.isLoading) {
      return;
    }
    clickedCard.isLoading = true;
    this.getSampleChatHistory(clickedCard);
  }

  getSampleChats() {
    this.isLoading = true;

    this.restService.getSampleChats(this.dataStore?.data?.id).subscribe({
      next: (response: any) => {
        this.cardItems = response?.titles;
        this.isLoading = false;
      },
      error: (error: any) => {
        this.toaster.pop({
          type: "error",
          text: MessageEnum.SAMPLE_CHATS_LOADING_ERROR,
        });
        this.isLoading = false;
      },
    });
  }

  getSampleChatHistory(card: CardData) {
    if (!card.threadId) {
      console.error("Card is missing a threadId.");
      return;
    }
    this.restService
      .getSampleChatHistory(this.dataStore?.data?.id, card.threadId)
      .subscribe({
        next: (response: any) => {
          console.log("chats history-->>", response);
          this.aiStreamingService.clearLastChat();
          this.agenticAiService.setHistory(this.agenticAiService.processChatHistory(response));
          this.sideNav.setTreeNode("workspace");
          card.isLoading = false; // Stop loading on success
        },
        error: (error: any) => {
          console.error("An error occurred while retrieving sample chat history:", error);
          this.toaster.pop({
            type: "error",
            text: MessageEnum.AI_GET_ALL_CHAT_HISTORY_SAMPLE,
          });
          card.isLoading = false; // Stop loading on error
        },
      });
  }
}
